/* Under CF7 form */

const thankYouPopup = {
    stepFormWrapper: document.querySelectorAll('.custom-step-form'),

    listenToAction(el) {

        jQuery(window).on('wpcf7mailsent', function () {
            const popup = document.querySelector('.cf7-custom-popup');
            if (popup) {
                popup.classList.add('active');
                const button = popup.querySelector('.close-popup');
                button.addEventListener('click', () => {
                    popup.classList.remove('active');
                });
            }
        });
    },
    init() {
        if (this.stepFormWrapper) {
            [...this.stepFormWrapper].forEach((el, ind) => {
                this.listenToAction(el);
            });
        }
    }
};

export default thankYouPopup;
